import React from "react";
import theme from "./theme";
import "./BankingOverview.css";

function cash(amount, currency = "USD") {
  if (amount == null) return "—";
  return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(amount);
}

export default function BankingOverview({ summary }) {
  return <section className="banking-overview" aria-label="Bank balances" style={Object.fromEntries(
    Object.entries(theme).filter(([, value]) => typeof value === "string").map(([key, value]) => [`--bank-${key}`, value])
  )}>
    <div className="banking-title"><h2>Bank balances</h2><span>USD totals · broker cash shown separately below</span></div>
    <div className="banking-panels">
      {summary.groups.map(group => <div className="banking-panel" key={group.name}>
        <div className="banking-panel-header"><div><h3>{group.name}</h3><p>{group.source}</p></div>
          <div className="banking-subtotal"><span>Subtotal · USD</span><strong>{cash(group.total)}</strong></div>
        </div>
        {group.rows.map((row, i) => <div className="banking-balance-row" key={`${row.label}-${i}`}>
          <div><div className="banking-entity">{row.label}</div><div className="banking-detail">{row.detail}</div></div>
          <div className={`banking-amount${row.amount < 0 ? " banking-negative" : ""}`}>{cash(row.amount, row.currency)}</div>
        </div>)}
        {!group.rows.length && <p className="banking-unavailable">No account balances available.</p>}
      </div>)}
    </div>
    {!summary.complete && <p className="banking-warning" role="status">Total cash is unavailable until all bank balances load. Missing balances and currencies without a USD conversion are not counted as zero.</p>}
  </section>;
}
